var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramBorderedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9940_2179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00406 1.77086C3.39656 2.00711 2.88281 2.32211 2.36906 2.83586C1.85531 3.34586 1.54031 3.86336 1.30406 4.46711C1.07531 5.05211 0.921563 5.72336 0.876563 6.70586C0.831562 7.68836 0.820312 8.00336 0.820312 10.5084C0.820312 13.0134 0.831562 13.3284 0.876563 14.3109C0.921563 15.2934 1.07906 15.9646 1.30406 16.5496C1.54031 17.1571 1.85531 17.6709 2.36906 18.1846C2.88281 18.6984 3.39656 19.0134 4.00406 19.2496C4.58906 19.4784 5.26031 19.6321 6.24281 19.6771C7.22531 19.7221 7.54031 19.7334 10.0453 19.7334C12.5503 19.7334 12.8653 19.7221 13.8478 19.6771C14.8303 19.6321 15.5016 19.4746 16.0866 19.2496C16.6941 19.0134 17.2078 18.6984 17.7216 18.1846C18.2353 17.6709 18.5503 17.1571 18.7866 16.5496C19.0153 15.9646 19.1691 15.2934 19.2141 14.3109C19.2591 13.3284 19.2703 13.0134 19.2703 10.5084C19.2703 8.00336 19.2591 7.68836 19.2141 6.70586C19.1691 5.72336 19.0116 5.05211 18.7866 4.46711C18.5503 3.86336 18.2353 3.34586 17.7253 2.83586C17.2116 2.32211 16.6978 2.00711 16.0903 1.77086C15.5053 1.54211 14.8341 1.38836 13.8516 1.34336C12.8691 1.29836 12.5541 1.28711 10.0491 1.28711C7.54406 1.28711 7.22906 1.29836 6.24656 1.34336C5.26031 1.38461 4.58906 1.54211 4.00406 1.77086ZM13.7728 3.00086C14.6728 3.04211 15.1603 3.19211 15.4866 3.31961C15.9178 3.48836 16.2253 3.68711 16.5478 4.00961C16.8703 4.33211 17.0691 4.63961 17.2378 5.07086C17.3653 5.39711 17.5153 5.88461 17.5566 6.78461C17.6016 7.75586 17.6091 8.04836 17.6091 10.5121C17.6091 12.9759 17.5978 13.2684 17.5566 14.2396C17.5153 15.1396 17.3653 15.6271 17.2378 15.9534C17.0691 16.3846 16.8703 16.6921 16.5478 17.0146C16.2253 17.3371 15.9178 17.5359 15.4866 17.7046C15.1603 17.8321 14.6728 17.9821 13.7728 18.0234C12.8016 18.0684 12.5091 18.0759 10.0453 18.0759C7.58156 18.0759 7.28906 18.0646 6.31781 18.0234C5.41781 17.9821 4.93031 17.8321 4.60406 17.7046C4.17281 17.5359 3.86531 17.3371 3.54281 17.0146C3.22031 16.6921 3.02156 16.3846 2.85281 15.9534C2.72531 15.6271 2.57531 15.1396 2.53406 14.2396C2.48906 13.2684 2.48156 12.9759 2.48156 10.5121C2.48156 8.04836 2.49281 7.75586 2.53406 6.78461C2.57531 5.88461 2.72531 5.39711 2.85281 5.07086C3.02156 4.63961 3.22031 4.33211 3.54281 4.00961C3.86531 3.68711 4.17281 3.48836 4.60406 3.31961C4.93031 3.19211 5.41781 3.04211 6.31781 3.00086C7.28906 2.95586 7.58156 2.94836 10.0453 2.94836C12.5091 2.94836 12.8016 2.95586 13.7728 3.00086Z",
    fill: "url(#paint0_radial_9940_2179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30859 10.5116C5.30859 13.1291 7.43109 15.2479 10.0448 15.2479C12.6586 15.2479 14.7811 13.1254 14.7811 10.5116C14.7811 7.89789 12.6623 5.77539 10.0448 5.77539C7.42734 5.77539 5.30859 7.89414 5.30859 10.5116ZM13.1198 10.5116C13.1198 12.2104 11.7436 13.5866 10.0448 13.5866C8.34609 13.5866 6.96984 12.2104 6.96984 10.5116C6.96984 8.81289 8.34609 7.43664 10.0448 7.43664C11.7436 7.43664 13.1198 8.81289 13.1198 10.5116Z",
    fill: "url(#paint1_radial_9940_2179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9725 6.69492C15.5834 6.69492 16.0787 6.19964 16.0787 5.58867C16.0787 4.97771 15.5834 4.48242 14.9725 4.48242C14.3615 4.48242 13.8662 4.97771 13.8662 5.58867C13.8662 6.19964 14.3615 6.69492 14.9725 6.69492Z",
    fill: "#654C9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9940_2179",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.15601 18.0445) rotate(-3.00009) scale(26.6743 22.6729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9940_2179",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.48039 14.3793) rotate(-3.00009) scale(13.6976 11.6428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9940_2179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.400391 0.900391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBorderedIcon);
export default __webpack_public_path__ + "static/media/instagram-bordered-icon.eea447e1.svg";
export { ForwardRef as ReactComponent };